import React, { useContext, useEffect, useState } from 'react';
import type { CaptchaData, CaptchaInputProps } from '../../signIn.types';
import { DFGModal, Icon, Image, Input, Tooltip, validIcons } from '@brahma/components';
import useLocale from '$hooks/use-locale';
import { ONBOARDING } from '$locale/constants';
import styles from './captchaInput.module.scss';
import { GlobalContext } from '$context/global-context';
import { useMutation } from '@brahma/hooks';
import type { IBFFResponse } from '@dfg/brahma-types';
import { API_URLS } from '$constants/apis';
import { POST } from '@brahma/utils';
const CaptchaInput = (props: CaptchaInputProps) => {
  const {
    captchaBase64,
    captchaInputValue,
    handleCaptchaInputChange,
    testId,
    onCaptchaGenerate,
    shouldGenerateCaptcha
  } = props;
  const {
    state
  } = useContext(GlobalContext);
  const isMobile = state.screen.isMobile;
  const {
    t: onboardingT
  } = useLocale(ONBOARDING);
  const [showMobileCaptchaHelpModal, setShowMobileCaptchaHelpModal] = useState(false);
  const toggleMobileCaptchaHelpModal = () => {
    setShowMobileCaptchaHelpModal(!showMobileCaptchaHelpModal);
  };
  const {
    mutateAsync: generateCaptcha,
    data: generatedCaptchaData
  } = useMutation<IBFFResponse<CaptchaData>, {}>({
    url: API_URLS.generateCaptcha,
    options: {
      method: POST
    },
    component: 'CaptchaInput'
  });
  const handleClickNewImage = () => {
    generateCaptcha({});
  };
  useEffect(() => {
    if (shouldGenerateCaptcha) {
      generateCaptcha({});
    }
  }, [shouldGenerateCaptcha]);
  useEffect(() => {
    if (generatedCaptchaData) {
      onCaptchaGenerate(generatedCaptchaData?.data as CaptchaData);
    }
  }, [generatedCaptchaData]);
  return <>
      <Input label={onboardingT('captcha.label')} name={onboardingT('captcha.name')} value={captchaInputValue} testId={testId} onChange={handleCaptchaInputChange} data-sentry-element="Input" data-sentry-source-file="index.tsx" />

      <div className={styles.catpchaBody}>
        <div className={styles.captchaImageContainer}>
          {captchaBase64 && <Image className={styles.captchaImage} imgClassName={styles.captchaImg} src={captchaBase64} alt="captcha" objectFit />}
        </div>

        <div className={styles.captchaFooter}>
          <div className={styles.generateNewCaptchaButton} onClick={handleClickNewImage}>
            <Icon iconName={validIcons.reload} width="10" height="10" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
            <div className={styles.generateNewCaptchaText}>
              {onboardingT('captcha.generateNewCaptchaText')}
            </div>
          </div>

          {isMobile ? <div className={styles.captchaHelpText}>
              <div onClick={toggleMobileCaptchaHelpModal}>
                <Icon iconName={validIcons.helpCircle03} width="12" height="12" />
              </div>
            </div> : <div className={styles.captchaHelpText}>
              <Tooltip text={onboardingT('captcha.helpModal.description')}>
                <Icon iconName={validIcons.helpCircle03} width="12" height="12" />
              </Tooltip>
            </div>}
        </div>
      </div>
      {showMobileCaptchaHelpModal && <DFGModal footerVariant="horizontal" show={showMobileCaptchaHelpModal} onBackdropClick={toggleMobileCaptchaHelpModal} modalClassName={styles.supportModal} header={{
      show: true,
      title: onboardingT('captcha.helpModal.title'),
      description: onboardingT('captcha.helpModal.description'),
      visibleDivider: false
    }} footer={{
      show: true,
      primaryText: onboardingT('captcha.helpModal.primaryText'),
      primaryAction: toggleMobileCaptchaHelpModal,
      visibleDivider: false,
      hideSecondaryAction: true
    }} />}
    </>;
};
export default CaptchaInput;